/* =========================================================================
   BUMPY VICE — noyau
   Écran de chargement, header HUD, menu pause, recherche, panier, toasts,
   onglets, carrousels. Aucune dépendance externe : tout tourne sans GSAP.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.BumpyConfig || {};

  var Bumpy = (window.Bumpy = window.Bumpy || {});
  Bumpy.config = cfg;
  Bumpy.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Petit bus d'évènements ------------------------------------------- */
  Bumpy.on = function (name, fn) { document.addEventListener('bumpy:' + name, fn); };
  Bumpy.emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent('bumpy:' + name, { detail: detail, bubbles: true }));
  };

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* =======================================================================
     Verrouillage du scroll (menus, tiroirs)
     ======================================================================= */
  var lockCount = 0;
  var scrollY = 0;

  function lockScroll() {
    if (lockCount++ === 0) {
      scrollY = window.scrollY;
      document.body.style.top = -scrollY + 'px';
      document.body.classList.add('is-locked');
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  }

  function unlockScroll() {
    if (lockCount > 0 && --lockCount === 0) {
      document.body.classList.remove('is-locked');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }
  }

  Bumpy.lockScroll = lockScroll;
  Bumpy.unlockScroll = unlockScroll;

  /* =======================================================================
     Écran de chargement
     ======================================================================= */
  function initLoader() {
    var loader = $('#bumpy-loader');
    if (!loader) return;

    if (root.classList.contains('loader-skip')) {
      loader.remove();
      return;
    }

    var duration = parseInt(loader.dataset.duration, 10) || 1400;
    if (Bumpy.reduceMotion) duration = 400;

    var fill = $('.loader__fill', loader);
    var pct = $('[data-loader-pct]', loader);
    var tipEl = $('.loader__tip', loader);

    // Astuce aléatoire.
    try {
      var tips = JSON.parse(loader.dataset.tips || '[]');
      if (tips.length && tipEl) tipEl.textContent = tips[Math.floor(Math.random() * tips.length)];
    } catch (e) { /* astuce par défaut conservée */ }

    lockScroll();

    var start = performance.now();
    (function step(now) {
      var p = Math.min(1, (now - start) / duration);
      // Courbe « chargement de jeu » : rapide puis ralentit.
      var eased = 1 - Math.pow(1 - p, 2.2);
      if (fill) fill.style.right = (100 - eased * 100) + '%';
      if (pct) pct.textContent = Math.round(eased * 100) + '%';
      if (p < 1) requestAnimationFrame(step);
      else finish();
    })(start);

    function finish() {
      loader.dataset.done = 'true';
      unlockScroll();
      try { sessionStorage.setItem('bumpy_loaded', '1'); } catch (e) { /* mode privé */ }
      setTimeout(function () { loader.remove(); Bumpy.emit('loader:done'); }, 500);
    }
  }

  /* =======================================================================
     Header : état au scroll + hauteur réelle exposée en CSS
     ======================================================================= */
  function initHeader() {
    var wrap = $('[data-header]');
    if (!wrap) return;

    var announcement = $('[data-announcement]');

    function measure() {
      var h = wrap.querySelector('.header');
      if (h) root.style.setProperty('--header-h', h.offsetHeight + 'px');
      root.style.setProperty('--announcement-h', (announcement ? announcement.offsetHeight : 0) + 'px');
      var top = wrap.getBoundingClientRect().bottom;
      root.style.setProperty('--mega-top', Math.max(0, top) + 'px');
      root.style.setProperty('--search-top', Math.max(0, top) + 'px');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        wrap.dataset.scrolled = window.scrollY > 12 ? 'true' : 'false';
        measure();
        ticking = false;
      });
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* =======================================================================
     Panneaux coulissants génériques (menu pause, tiroir, filtres, recherche)
     ======================================================================= */
  var openPanels = [];

  function openPanel(panel, opener) {
    if (!panel || panel.getAttribute('aria-hidden') === 'false') return;
    panel.setAttribute('aria-hidden', 'false');
    panel.__opener = opener || document.activeElement;
    openPanels.push(panel);
    lockScroll();
    showOverlay();

    var focusable = panel.querySelector('[autofocus], button, [href], input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);

    $$('[aria-controls="' + panel.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    Bumpy.emit('panel:open', { panel: panel });
  }

  function closePanel(panel) {
    if (!panel || panel.getAttribute('aria-hidden') === 'true') return;
    panel.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== panel; });
    unlockScroll();
    if (!openPanels.length) hideOverlay();
    if (panel.__opener && document.body.contains(panel.__opener)) panel.__opener.focus({ preventScroll: true });

    $$('[aria-controls="' + panel.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    Bumpy.emit('panel:close', { panel: panel });
  }

  Bumpy.openPanel = openPanel;
  Bumpy.closePanel = closePanel;

  function showOverlay() {
    var o = $('#bumpy-overlay');
    if (o) o.setAttribute('aria-hidden', 'false');
  }
  function hideOverlay() {
    var o = $('#bumpy-overlay');
    if (o) o.setAttribute('aria-hidden', 'true');
  }

  function initPanels() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-panel-open]');
      if (opener) {
        e.preventDefault();
        var target = document.getElementById(opener.dataset.panelOpen);
        if (target) {
          target.getAttribute('aria-hidden') === 'false' ? closePanel(target) : openPanel(target, opener);
        }
        return;
      }

      var closer = e.target.closest('[data-panel-close]');
      if (closer) {
        e.preventDefault();
        var panel = closer.dataset.panelClose
          ? document.getElementById(closer.dataset.panelClose)
          : closer.closest('[aria-hidden]');
        closePanel(panel);
        return;
      }

      if (e.target.id === 'bumpy-overlay') {
        openPanels.slice().reverse().forEach(closePanel);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openPanels.length) return;
      closePanel(openPanels[openPanels.length - 1]);
    });

    // Panneaux qui ne sont des tiroirs que sur petit écran (filtres de
    // collection) : sur ordinateur ils font partie de la page, donc on
    // retire aria-hidden pour ne pas les masquer aux lecteurs d'écran.
    var wide = window.matchMedia('(min-width: 990px)');

    function syncResponsivePanels() {
      $$('[data-panel-responsive]').forEach(function (panel) {
        if (wide.matches) {
          panel.removeAttribute('aria-hidden');
        } else if (!panel.hasAttribute('aria-hidden')) {
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    }

    syncResponsivePanels();
    if (wide.addEventListener) wide.addEventListener('change', syncResponsivePanels);
    else if (wide.addListener) wide.addListener(syncResponsivePanels);
    document.addEventListener('bumpy:facets:updated', syncResponsivePanels);
  }

  /* =======================================================================
     Menu pause (mobile) : sous-menus dépliables
     ======================================================================= */
  function initPauseMenu() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-submenu-toggle]');
      if (!toggle) return;
      e.preventDefault();
      var sub = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!sub) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      sub.hidden = open;
    });
  }

  /* =======================================================================
     Notifications HUD
     ======================================================================= */
  var audioCtx = null;

  function blip(ok) {
    if (!cfg.sound) return;
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      var t = audioCtx.currentTime;
      var osc = audioCtx.createOscillator();
      var gain = audioCtx.createGain();
      osc.type = 'square';
      osc.frequency.setValueAtTime(ok ? 660 : 180, t);
      osc.frequency.exponentialRampToValueAtTime(ok ? 1320 : 110, t + 0.09);
      gain.gain.setValueAtTime(0.06, t);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.18);
      osc.connect(gain).connect(audioCtx.destination);
      osc.start(t);
      osc.stop(t + 0.2);
    } catch (e) { /* audio indisponible : on ignore */ }
  }

  var CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var ALERT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 8v5M12 17h.01"/><path d="M10.3 3.9L2.4 17.5A2 2 0 0 0 4.1 20.5h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>';

  Bumpy.toast = function (opts) {
    var stack = $('#bumpy-toasts');
    if (!stack) return;

    var el = document.createElement('div');
    el.className = 'toast' + (opts.error ? ' toast--error' : '');
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<div class="toast__icon">' + (opts.error ? ALERT_ICON : CHECK_ICON) + '</div>' +
      '<div>' +
        '<div class="toast__title">' + escapeHtml(opts.title || '') + '</div>' +
        (opts.subtitle ? '<div class="toast__sub">' + escapeHtml(opts.subtitle) + '</div>' : '') +
      '</div>';

    stack.appendChild(el);
    blip(!opts.error);

    setTimeout(function () {
      el.dataset.leaving = 'true';
      setTimeout(function () { el.remove(); }, 400);
    }, opts.duration || 3600);
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* =======================================================================
     PANIER
     ======================================================================= */
  var DRAWER_SECTION = 'cart-drawer';

  function cartSectionsParam() {
    // Le tiroir est toujours rendu ; la page panier a sa propre section.
    var list = [DRAWER_SECTION];
    if ($('#shopify-section-main-cart')) list.push('main-cart');
    return list.join(',');
  }

  function applySections(sections) {
    if (!sections) return;

    // Le tiroir est re-rendu par le serveur : il revient donc fermé.
    // On mémorise son état pour le restaurer, sinon il se refermerait
    // à chaque changement de quantité.
    var oldDrawer = $('#cart-drawer');
    var wasOpen = oldDrawer && oldDrawer.getAttribute('aria-hidden') === 'false';

    Object.keys(sections).forEach(function (id) {
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });

    if (wasOpen) {
      var newDrawer = $('#cart-drawer');
      if (newDrawer && newDrawer !== oldDrawer) {
        newDrawer.setAttribute('aria-hidden', 'false');
        newDrawer.__opener = oldDrawer.__opener;
        // Le verrou de scroll reste actif : on remplace juste la référence.
        openPanels = openPanels.map(function (p) { return p === oldDrawer ? newDrawer : p; });
      }
    }

    syncHeaderFromCart();
    Bumpy.emit('cart:updated');
  }

  // Le tiroir expose l'état du panier (nombre + total formaté) : le header le recopie.
  function syncHeaderFromCart() {
    var state = $('[data-cart-state]');
    if (!state) return;
    var count = state.dataset.count || '0';
    var money = state.dataset.money || '';

    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
    $$('[data-cart-money]').forEach(function (el) {
      if (el.textContent.trim() !== money) {
        el.textContent = money;
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });
  }

  function openCartDrawer() {
    var drawer = $('#cart-drawer');
    if (drawer && cfg.cartType === 'drawer') openPanel(drawer);
  }
  Bumpy.openCart = openCartDrawer;

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: cartSectionsParam(), sections_url: window.location.pathname }, body))
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  Bumpy.addToCart = function (formData, submitter) {
    formData.set('sections', cartSectionsParam());
    formData.set('sections_url', window.location.pathname);

    if (submitter) {
      submitter.setAttribute('aria-disabled', 'true');
      submitter.dataset.loading = 'true';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        applySections(data.sections);
        Bumpy.toast({
          title: cfg.toastTitle || 'MISSION ACCOMPLIE',
          subtitle: cfg.toastSubtitle || '+1 BEAST MODE'
        });
        openCartDrawer();
        return data;
      })
      .catch(function (err) {
        Bumpy.toast({
          error: true,
          title: cfg.strings && cfg.strings.error ? cfg.strings.error : 'ÉCHEC',
          subtitle: (err && (err.description || err.message)) || ''
        });
        throw err;
      })
      .finally(function () {
        if (submitter) {
          submitter.removeAttribute('aria-disabled');
          delete submitter.dataset.loading;
        }
      });
  };

  function initCart() {
    // Ajout au panier depuis n'importe quel formulaire produit.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      Bumpy.addToCart(new FormData(form), form.querySelector('[data-add-button]')).catch(function () {});
    });

    // Changement de quantité / suppression dans le panier.
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        var line = remove.closest('[data-line]');
        if (line) line.classList.add('is-updating');
        cartRequest('/cart/change.js', { line: parseInt(remove.dataset.cartRemove, 10), quantity: 0 })
          .then(function (d) { applySections(d.sections); })
          .catch(function () { if (line) line.classList.remove('is-updating'); });
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var line = input.closest('[data-line]');
      if (line) line.classList.add('is-updating');
      cartRequest('/cart/change.js', {
        line: parseInt(input.dataset.cartQty, 10),
        quantity: Math.max(0, parseInt(input.value, 10) || 0)
      })
        .then(function (d) { applySections(d.sections); })
        .catch(function () { if (line) line.classList.remove('is-updating'); });
    });

    // Note de commande.
    var noteTimer;
    document.addEventListener('input', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }, 600);
    });

    syncHeaderFromCart();
  }

  /* =======================================================================
     Sélecteurs de quantité
     ======================================================================= */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;

      var step = parseInt(btn.dataset.qtyStep, 10);
      var min = parseInt(input.min, 10) || 0;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + step));

      if (next === parseInt(input.value, 10)) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* =======================================================================
     Onglets produit (ordinateur) — les accordéons mobiles sont en <details>
     ======================================================================= */
  function initTabs() {
    $$('[data-tabs]').forEach(function (tabs) {
      if (tabs.dataset.tabsReady === 'true') return;
      tabs.dataset.tabsReady = 'true';

      var buttons = $$('[role="tab"]', tabs);
      if (!buttons.length) return;

      function select(btn) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', String(on));
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[role="tab"]');
        if (btn) select(btn);
      });

      tabs.addEventListener('keydown', function (e) {
        var i = buttons.indexOf(document.activeElement);
        if (i < 0) return;
        var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -1;
        if (next < 0) return;
        e.preventDefault();
        var target = buttons[(next + buttons.length) % buttons.length];
        target.focus();
        select(target);
      });
    });
  }

  /* =======================================================================
     Carrousels (flèches + état des boutons)
     ======================================================================= */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (track) {
      if (track.dataset.carouselReady === 'true') return;
      track.dataset.carouselReady = 'true';

      var nav = document.querySelector('[data-carousel-nav="' + track.dataset.carousel + '"]');
      if (!nav) return;
      var prev = nav.querySelector('[data-dir="prev"]');
      var next = nav.querySelector('[data-dir="next"]');

      function step(dir) {
        var first = track.firstElementChild;
        var amount = first ? first.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: Bumpy.reduceMotion ? 'auto' : 'smooth' });
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        nav.hidden = max <= 2;
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* =======================================================================
     Barre d'achat collante (mobile) : apparaît quand le bouton principal
     sort de l'écran.
     ======================================================================= */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    if (bar.dataset.stickyReady === 'true') return;
    bar.dataset.stickyReady = 'true';

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -100% 0px' }).observe(anchor);
  }

  /* =======================================================================
     Zoom galerie produit : l'origine du zoom suit la souris.
     ======================================================================= */
  function initGalleryZoom() {
    $$('[data-zoom]').forEach(function (slide) {
      if (slide.dataset.zoomReady === 'true') return;
      slide.dataset.zoomReady = 'true';

      slide.addEventListener('mousemove', function (e) {
        var r = slide.getBoundingClientRect();
        slide.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
        slide.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
      slide.addEventListener('mouseleave', function () {
        slide.style.setProperty('--zx', '50%');
        slide.style.setProperty('--zy', '50%');
      });
    });
  }

  /* =======================================================================
     Compte à rebours des bannières promo
     ======================================================================= */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.countdownReady === 'true') return;
      el.dataset.countdownReady = 'true';

      var end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      var parts = {
        d: el.querySelector('[data-cd="d"]'),
        h: el.querySelector('[data-cd="h"]'),
        m: el.querySelector('[data-cd="m"]'),
        s: el.querySelector('[data-cd="s"]')
      };

      (function tick() {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        if (parts.d) parts.d.textContent = pad(Math.floor(s / 86400));
        if (parts.h) parts.h.textContent = pad(Math.floor(s / 3600) % 24);
        if (parts.m) parts.m.textContent = pad(Math.floor(s / 60) % 60);
        if (parts.s) parts.s.textContent = pad(s % 60);
        if (diff > 0) setTimeout(tick, 1000);
        else el.dispatchEvent(new CustomEvent('countdown:end'));
      })();
    });
  }

  /* =======================================================================
     Lecteurs vidéo « bande-annonce » : l'iframe n'est injectée qu'au clic,
     ce qui évite de charger YouTube au chargement de la page.
     ======================================================================= */
  function initTrailers() {
    document.addEventListener('click', function (e) {
      var play = e.target.closest('[data-trailer-play]');
      if (!play) return;
      var trailer = play.closest('[data-trailer]');
      if (!trailer || trailer.dataset.playing === 'true') return;

      var src = trailer.dataset.embed;
      var video = trailer.querySelector('video');

      if (video) {
        video.play();
      } else if (src) {
        var frame = document.createElement('iframe');
        frame.src = src;
        frame.title = trailer.dataset.title || 'Vidéo';
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.allowFullscreen = true;
        frame.loading = 'lazy';
        trailer.appendChild(frame);
      }
      trailer.dataset.playing = 'true';
    });
  }

  /* =======================================================================
     Newsletter & formulaires : focus sur le message de retour
     ======================================================================= */
  function initFormFeedback() {
    var msg = $('.form-message[data-autofocus]');
    if (msg) msg.scrollIntoView({ block: 'center', behavior: Bumpy.reduceMotion ? 'auto' : 'smooth' });
  }

  /* =======================================================================
     Démarrage
     ======================================================================= */
  function init() {
    initLoader();
    initHeader();
    initPanels();
    initPauseMenu();
    initCart();
    initQuantity();
    initTabs();
    initCarousels();
    initStickyBuy();
    initGalleryZoom();
    initCountdowns();
    initTrailers();
    initFormFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Le contenu re-rendu par l'éditeur de thème doit retrouver ses comportements.
  document.addEventListener('shopify:section:load', function () {
    initCarousels();
    initTabs();
    initGalleryZoom();
    initCountdowns();
    initStickyBuy();
  });

  // Le panier change → les carrousels du tiroir se recalculent.
  Bumpy.on('cart:updated', initCarousels);
})();
